<template>
    <div>
        <div class="page-main-title-right">
            <el-button type="text underline" @click="$router.push('/manage/contractdetails')">查看电子合同</el-button>
        </div>
        <div class="content-box first">
            <el-table class="authorize-table" v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column :min-width="150" label="授权专辑">
                    <template slot-scope="scope">
                        <div class="album-info">
                            <el-image :src="$utils.coverImg(scope.row.albumCover, 60, 60)"
                                :preview-src-list="[$utils.coverImg(scope.row.albumCover)]" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            {{ scope.row.albumName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :min-width="200" label="授权歌曲">
                    <template slot-scope="scope">
                        <span v-for="(item, index) in scope.row.albumTracks" :key="index" href="">《{{ item.trackName
                        }}》</span>
                    </template>
                </el-table-column>
                <el-table-column label="授权开始时间 / 结束时间" width="200">
                    <template slot-scope="scope">
                        <span>{{ $utils.formatDate(scope.row.authBeginTime, 'yyyy.MM.dd') }} / {{
                            $utils.formatDate(scope.row.authEndTime, 'yyyy.MM.dd')
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" :min-width="60">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isAllowInterruptRenew == 1"
                            @click="currentRow = scope.row; visible = true;" type="text">
                            终止授权
                        </el-button>
                        <p v-if="scope.row.ifAutoRenew == 0" class="color-info">已终止授权</p>
                        <p v-if="scope.row.ifAutoRenew == 2" class="color-info">受理中</p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-pagination-box">
                <el-pagination background :current-page.sync="filterData.pageNo" :page-sizes="[10, 20, 30]"
                    :page-size.sync="filterData.pageSize" layout="prev, pager, next" :total="totalCount"
                    @size-change="fetch" @current-change="fetch"></el-pagination>
            </div>
            <el-dialog title="终止授权" append-to-body :show-close="false" center :visible.sync="visible" width="540px">
                <p class="dialog-tip">
                    申请终止授权后，将会在{{ $utils.formatDate(currentRow.authEndTime) }}终止授权。
                    <br />
                    届时将下架各个平台上终止授权的歌曲，且不再结算版权收益。
                    <br />
                    <span class="color-base">请慎重选择，重新上架会有等待时间</span>，如有问题请联系客服
                </p>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" class="underline" @click="terminateAuthorization()">申请终止授权</el-button>
                    <el-button class="dialog-back" @click="visible = false" size="mini" type="info">取消</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
const defaultQuery = {
    pageNo: 1,
    pageSize: 10,
};
export default {
    data() {
        return {
            visible: false,
            loading: false,
            tableData: [],
            filterData: { ...defaultQuery },
            totalCount: 0,
            currentRow: {},
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        spanMethod({ row, columnIndex }) {
            if (columnIndex === 0 || columnIndex === 2 || columnIndex === 3) {
                return {
                    rowspan: row.rowspan,
                    colspan: 1,
                };
            } else {
                return {
                    rowspan: 1,
                    colspan: 1,
                };
            }
        },
        // To Fetch
        search() {
            this.filterData.pageNo = 1;
            this.fetch();
        },
        // Reset fetch
        reset() {
            this.filterData = { ...defaultQuery };
            this.fetch();
        },
        async terminateAuthorization() {
            const { authId, albumId } = this.currentRow;
            const res = await this.$request({
                url: '/breakRenewal/applyCpAuthorizeInterrupt',
                data: { authId, albumId },
                method: 'POST',
                formData: false,
            });
            const { state, msg } = res.data;
            this.dataLoading = false;
            if (!state) return this.$message.error(msg || '请求失败');
            this.$message.success('操作成功');
            this.visible = false;
            this.fetch();
        },
        //获取列表数据
        async fetch() {
            this.dataLoading = true;
            const res = await this.$request({
                url: '/breakRenewal/listCpAlbumAuthorize',
                data: this.filterData,
                method: 'POST',
                formData: false,
            });
            const { state, msg, result } = res.data;
            this.dataLoading = false;
            if (!state) return this.$message.error(msg || '请求失败');
            this.tableData = result.result || [];
            this.totalCount = result.totalCount;
            this.filterData.pageNo = result.pageNo;
        },
    },
};
</script>
<style lang="scss">
.album-info {
    display: flex;
    align-items: center;

    .el-image {
        width: 60px;
        height: 60px;
        border-radius: 10px;
        margin-right: 20px;
    }
}
</style>
